<template>
  <div class="bg-gray20">
    <div class="container BODY-CONTAINER">
      <transition name="fade" mode="out-in">
        <div class="d-flex fd-column ai-center">
          <vk-icon
              class="CHECK-GREEN p-b-5"
              name="filled-check"
              size="72"
          />
          <div class="h3 text-center">Texts Activated</div>
          <div class="text-center">
            You have successfully subscribed to text messages
            and will no longer receive e-mails from us.
          </div>
          <div class="p-y-5">
            <router-link :to="{name: 'consumer::dashboard'}" class="btn ROUNDED">
              <span class="p-x-1">View my account</span>
            </router-link>
          </div>
          <div class="p-t-5">Pro Referral may send you text messages about this service request.
          Message & data rates may apply.
          Texts message frequency varies and may be sent between 8:00 am & 9:00 pm.
          Text STOP to cancel or HELP for help. For questions, contact 1-855-723-2266.
            <router-link :to="{ name: 'about::legal::privacy' }" class="link">
              Privacy & Security Statement
            </router-link>
          </div>

        </div>
      </transition>
    </div>
  </div>
</template>

<script>


export default {
  name: 'opt-in-success',
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.BODY-CONTAINER {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  max-width: 780px;
  @include mobile-only() {
    max-width: 95vw;
  }
}
.ROUNDED {
  border-radius: 5px;
}
.CHECK-GREEN {
  color: #389E0D;
}
</style>
